import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=b5de5770&"
import script from "./userDetails.vue?vue&type=script&lang=js&"
export * from "./userDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports